import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as sendMail from "../request/sendMail";

const estadoInicial = {
  loading: false,
  data: "",
  error: "",
  alert: false,
  msg: ""
};

export const sendMessage = createAsyncThunk(
  "ENVIAR_MENSAJE",
  sendMail.enviarMensaje
);
export const resetStatus = createAsyncThunk(
  "RESET",
  ()=>{
    console.log('reset ok!')
  }
);


const sendSlice = createSlice({
  name: "enviarMensaje",
  initialState: estadoInicial,
  extraReducers: {
    [sendMessage.pending]: (state, action) => {
      state.loading = true;
    },
    [sendMessage.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.alert = true;
      state.msg = "Mensaje enviado"
    },
    [sendMessage.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.alert = true;
      state.msg = "Mensaje NO enviado"
    },
    [resetStatus.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = "";
      state.error= "";
      state.alert = false;
      state.msg = ""
    },
  }
});

export default sendSlice.reducer;